import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Classes from '../views/Classes.vue'
import Syllabus from '../views/Syllabus.vue'
import DanceDetails from '../views/DanceDetails.vue'
import FigureDetails from '../views/FigureDetails.vue'
import SyllabusStyleDetails from '../views/SyllabusStyleDetails.vue'
import adminClassDetails from '../views/adminClassDetails.vue'
import adminLessonDetails from '../views/adminLessonDetails.vue'
import playerView from '../views/playerView.vue'
import Admin from '../views/Admin.vue'
import Register from '../views/Register.vue'
import Login from '../views/Login.vue'
import firebase from 'firebase'
import { db } from '../main'



Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: Home
  },
  {
    path: '/signup',
    name: 'Register',
    component: Register
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/privacy',
    name: 'Privacy Policy',
    component: () => import('../views/privacypolicy.vue')
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: { requiresAdmin: true },
  },
  {
    path: '/admin/:classKey',
    name: 'adminClassDetails',
    component: adminClassDetails,
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/:classKey/:lessonKey',
    name: 'adminLessonDetails',
    component: adminLessonDetails,
    meta: { requiresAdmin: true }
  },
  {
    path: '/classes',
    name: 'Classes',
    component: Classes,
  },
  {
    path: '/classes/:id',
    name: 'playerView',
    component: playerView,
    children: [
      {
        path: ':lessonid',
        name: 'LessonView',
        component: playerView,
      }
    ]
  },
  {
    path: '/syllabus',
    name: 'Syllabus',
    component: Syllabus,
  },
  {
    path: '/syllabus/:style',
    name: 'SyllabusStyleDetails',
    component: SyllabusStyleDetails,
    children: [
      {
        path: ':danceid',
        name: 'DanceDetails',
        component: DanceDetails,
      }
    ]
  },
  {
    path: '/syllabus/:style/:danceid/:figure',
    name: 'FigureDetails',
    component: FigureDetails,
  },
  {
    path: '/channels',
    name: 'Professionals',
    component: () => import('../views/instructors.vue'),
  },
  {
    path: '/channels/:uid',
    name: 'instructorDetails',
    component: () => import('../views/instructorDetails.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
  const currentUser = firebase.auth().currentUser

  if (requiresAdmin) {
    if (!currentUser) {
      console.log("Access denied")
      next('/login');
    } else {
      var isAdmin = db.ref(`users/${currentUser.uid}/admin`).once('value')
      if (!isAdmin) {
        next('/classes');
      } else {
        next()
      }
    }
  } else {
    next()
  }
}
)

export default router
